import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';
import styled from 'styled-components';

type SettingsListItemProps = { item: RouteDefinition };

export const SettingMenuItem = observer(({ item }: SettingsListItemProps) => {
    const name = item.menuTitle?.();

    return (
        <StyledNavLink to={item.path}>
            <Tooltip title={name}>
                <EllipsisContainer
                    data-testid={`master-details-list-item-${item.key}`}
                >
                    {name}
                </EllipsisContainer>
            </Tooltip>
        </StyledNavLink>
    );
});

const StyledNavLink = styled(NavLink)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--aside-list-item-bg);
    color: var(--form-text-color);
    padding: 0.75rem 1rem;
    font-size: 1.0625rem;
    line-height: 125%;
    letter-spacing: -0.3px;
    text-decoration: none !important;
    margin-top: 0.7rem;

    &:hover {
        border-radius: 0.75rem;
        background: #f5f5f5;
        color: var(--form-text-color);
    }

    &.active {
        border-radius: 0.75rem;
        background: #f5f5f5;
        color: var(--form-text-color);
    }
`;
